import en from './en.js'
import tr from './tr.js'

const language = {
    en: {...en},
    tr: {...tr},
};

export default language;